<div [@bannerState]="state">
  <p-messages class="strategies-message" *ngIf="isMessagesVisible" [value]="messages" (valueChange)="onMessagesClosed($event)"></p-messages>
</div>
